import httpService from '@/utils/http-service'
import store from '@/store'

const module = 'staff'
const controller = 'notice'

export function searchNotice(params) {
	return httpService.request({
		url: `${module}/${controller}/search`,
		params
	})
}

export function submitSettingNotice() {
	return httpService.request({
		method: 'POST',
		url: `${module}/${controller}/submitSetting`,
	}).then(res=> {
		store.commit('clearUnreadNotice')
		return res
	})
}